const getSettings = () => {
    const SSR_AFFILIATES = typeof process.env.SSR_AFFILIATES !== 'undefined'
            ? process.env.SSR_AFFILIATES
            : '';

    const SSR_ON = (process.env.SSR_ON === 'false'
      || process.env.SSR_ON === '0') ? false : true;

    const SSR_PASSING_REDUX = (process.env.SSR_PASSING_REDUX === 'false'
      || process.env.SSR_PASSING_REDUX === '0') ? false : true;

    return {SSR_ON, SSR_AFFILIATES, SSR_PASSING_REDUX};
};

const isMatchedAffiliates = (affiliateName) => {
    if (!getSettings().SSR_AFFILIATES) {
        return true;
    }
    let arr = getSettings().SSR_AFFILIATES.split(',').map(str => str.trim());
    let isMatched = false;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].toLowerCase() === affiliateName.toLowerCase()) {
            isMatched = true;
            break;
        }
    }
    return isMatched;
};

const isSSR = (affiliateName) => {
    return getSettings().SSR_AFFILIATES
            ? isMatchedAffiliates(affiliateName) && getSettings().SSR_ON
            : getSettings().SSR_ON;
};

// if match any of config.notAllowableAPIs, then return false;
const isAllowable = (url) => {
    let matched = config.notAllowableAPIs.filter(entry => {
        if (typeof entry === 'object' && entry instanceof RegExp && typeof url === 'string' && url.match(entry)) {
            return true;
        } else if (url === entry) {
            return true;
        }
        return false;
    });

    return matched.length > 0 ? false : true;
};

const config = {
    isMatchedAffiliates,
    isSSR,
    isAllowable,
    settings: getSettings(),
    components: {   // components not specified here will be assumed client-side rendering only
        'components/core/Header': {ssr: true},
        'components/core/CollapsibleHeader': {ssr: true},
        'components/core/TallHeader': {ssr: true},
        'components/core/SimpleNavigation': {ssr: true},
        'components/core/FooterNavigation': {ssr: true},
        'components/core/Footer': {ssr: true},
        'components/news/CardContainer': {ssr: true},
        'components/news/Card': {ssr: true},
        'components/news/CardList': {ssr: true},
        'components/news/Clip': {ssr: true},
        'components/news/Article': {ssr: true},
        'components/news/ArticleList': {ssr: true},
        'components/news/NewsBanner': {ssr: true},
        'components/news/AssociatedContent': {ssr: true},
        'components/news/SliderArticleList': {ssr: true},
        'components/weather/MeteorologistForecast': {ssr: true},
        'components/media/VideoPlayer': {ssr: true},
        'components/media/NewsyVideo': {ssr: true},
        'components/media/LiveStreamVideo': {ssr: true},
        'components/media/VideoThumbnail': {ssr: true},
        'components/media/Video': {ssr: true},
        'components/shared/PageTitle': {ssr: true},
        'components/shared/CodeBlock': {ssr: true},
        'components/shared/Link': {ssr: true},
        'components/shared/IFrame_new': {ssr: true},
        'components/news/Slideshow': {ssr: true},
        'components/news/ImageSlideshow': {ssr: true},
        'components/news/CategoryGrid': {ssr: true},
        'components/weather/StationImages': {ssr: true},
        'components/custom/ssr/Footer': {ssr: true},
        'components/custom/ssr/Header': {ssr: true},
        'components/custom/ssr/HomePageTakeover': {ssr: true},
        'components/custom/ssr/SendTo': {ssr: true},
        'components/custom/ssr/WeatherTakeover': {ssr: true},
        'components/custom/ssr/WarnEspRadar': {ssr: true},
        'components/custom/ssr/WeatherBlock': {ssr: true},
        'components/custom/ssr/UControl': {ssr: true},
        'components/custom/ssr/Seismograph': {ssr: true},
        'components/custom/ssr/EarthquakeMap': {ssr: true},
        'components/custom/ssr/SchoolClosings': {ssr: true},
        'components/custom/ssr/ElectionPage': {ssr: true},
        'components/custom/ssr/TrafficPage': {ssr: true},
        'components/custom/ssr/LayoutFullBleed': {ssr: true},
        'components/custom/ssr/LayoutOneByFive': {ssr: true},
        'components/custom/ssr/LayoutTwoByFour': {ssr: true},
        'components/custom/ssr/LayoutTwoByThree': {ssr: true},
        'components/custom/ssr/LayoutCarousel': {ssr: true},
        'components/custom/ssr/LayoutOneTwoThree': {ssr: true},
        'components/custom/ssr/LayoutLandscapeList': {ssr: true},
        'components/custom/ssr/LayoutOneTwoList': {ssr: true},
        'components/custom/ssr/LayoutThreeByN': {ssr: true},
        'components/custom/ssr/LayoutOneFeature': {ssr: true},
        'components/custom/ssr/LayoutCarouselWithFeature': {ssr: true},
        'components/custom/ssr/WatchesAndWarnings': {ssr: true},
        'components/custom/ssr/HelperDarkBackground': {ssr: true},
        'components/custom/ssr/PageTitle': {ssr: true},
        'components/custom/ssr/HourlyTemperatures': {ssr: true},
        'components/custom/ssr/Almanac': {ssr: true},
        'components/custom/ssr/NineDayForecast': {ssr: true},
        'components/custom/ssr/PlayFirstClipFromCategory': {ssr: true},
        'components/custom/ssr/RadarCallToAction': {ssr: true},
        'components/custom/ssr/SkyCam': {ssr: true},
        'components/custom/ssr/SkycamPage': {ssr: true},
        'components/custom/ssr/WeatherAppAdvert': {ssr: true},
        'components/custom/ssr/WeatherSummary': {ssr: true},
        'components/custom/ssr/WindChart': {ssr: true},
        'components/custom/ssr/ArchiveCalendar': {ssr: true},
        'components/custom/ssr/Image': {ssr: true},
        'components/custom/ssr/ResponsiveAdContainer': {ssr: true},
        'components/custom/ssr/WeatherAlerts': {ssr: true},
        'components/custom/ssr/RadioBanner': {ssr: true},
        'components/custom/ssr/BaronAlmanac': {ssr: true},
        'components/custom/ssr/BaronHourlyTemperatures': {ssr: true},
        'components/custom/ssr/BaronWindChart': {ssr: true},
        'components/custom/ssr/BaronResponsiveMap': {ssr: true},
        'components/custom/ssr/BaronNineDayForecast': {ssr: true},
        'components/custom/ssr/BaronWeatherBlock': {ssr: true},
        'components/custom/ssr/BaronWeatherSummary': {ssr: true},
        'components/custom/ssr/BaronSimpleDatePicker': {ssr: true},
        'components/custom/ssr/DataStore': {ssr: true},
        'components/custom/ssr/LayoutRightRailStories': {ssr: true},
        'components/custom/ssr/LayoutTwoThree': {ssr: true},
        'components/Timestamp': {ssr: true},
        'components/AdvertisementUnit': {ssr: true}
    },
    notAllowableAPIs: [
        /\$/gi,
        '/api/integrations/wsi/current',
    ]
};

export default {ssr: config};



// WEBPACK FOOTER //
// ./server/config/ssr.js